import documentTypesService from '@/services/documentTypes.service'

export default {
  namespaced: true,
  state: {
    documentTypes: [],
    loading: false,
    error: null
  },
  mutations: {
    SET_DOCUMENT_TYPES(state, documentTypes) {
      state.documentTypes = documentTypes
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    ADD_DOCUMENT_TYPE(state, documentType) {
      state.documentTypes.push(documentType)
    },
    UPDATE_DOCUMENT_TYPE(state, updatedDocumentType) {
      const index = state.documentTypes.findIndex(d => d.id === updatedDocumentType.id)
      if (index !== -1) {
        state.documentTypes.splice(index, 1, updatedDocumentType)
      }
    },
    REMOVE_DOCUMENT_TYPE(state, id) {
      state.documentTypes = state.documentTypes.filter(d => d.id !== id)
    }
  },
  actions: {
    async fetchDocumentTypes({ commit }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await documentTypesService.getAll()
        // Handle paginated response - data is nested in response.data.data
        const documentTypes = response.data?.data || response.data || []
        commit('SET_DOCUMENT_TYPES', documentTypes)
      } catch (error) {
        commit('SET_ERROR', error.response?.data?.message || error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createDocumentType({ commit }, documentTypeData) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await documentTypesService.create(documentTypeData)
        if (response.success) {
          commit('ADD_DOCUMENT_TYPE', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateDocumentType({ commit }, { id, documentTypeData }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await documentTypesService.update(id, documentTypeData)
        if (response.success) {
          commit('UPDATE_DOCUMENT_TYPE', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async deleteDocumentType({ commit }, id) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await documentTypesService.delete(id)
        if (response.success) {
          commit('REMOVE_DOCUMENT_TYPE', id)
          return { success: true }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    allDocumentTypes: state => state.documentTypes,
    activeDocumentTypes: state => state.documentTypes.filter(d => d.active),
    requiredDocumentTypes: state => state.documentTypes.filter(d => d.is_required && d.active),
    isLoading: state => state.loading
  }
}

